import { render, staticRenderFns } from "./ShortPageLimit.vue?vue&type=template&id=3df2f78e"
import script from "./ShortPageLimit.vue?vue&type=script&lang=js"
export * from "./ShortPageLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports